<div class="card m-0 bg-transparent">
  <div class="card-body">
    <div class="mb-3">
      <label
        for="text-color"
        class="offcanvas-header-text w-100"
        style="text-align: left"
      >
        <ng-container *ngIf="type === chatTypes?.GROUP">
          {{ "GENERALS.SELECTGROUP" | translate }}
        </ng-container>

        <ng-container *ngIf="type === chatTypes?.CHANNEL">
          {{ "GENERALS.SELECTCHANNEL" | translate }}
        </ng-container>
      </label>
      <div class="row justify-content-between">
        <div class="col-5">
          <div
            class="input-group offcanvas-border-primary border rounded-2"
            title="Using format option"
          >
            <input
              type="text"
              id="text-color"
              class="form-control input-lg offcanvas-primary border-0"
              [value]="chatId"
              disabled
              readOnly
            />
          </div>
        </div>
        <div class="col-5 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary"
            (click)="openUsersSelector(selectorChats)"
          >
            {{ "GENERALS.SET" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #selectorChats let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="selector">
      <ng-container *ngIf="type === chatTypes?.GROUP"> Groups </ng-container>

      <ng-container *ngIf="type === chatTypes?.CHANNEL"> Channel </ng-container>
    </h5>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="cancelChatSelector()"
    ></button>
  </div>
  <div class="modal-body p-0">
    <app-chats-selector
      [mode]="'selector'"
      [single]="true"
      [type]="type"
      [selectedChats]="selectedChats"
      (selectedNotifier)="selectedChatsf($event)"
      (cancelNotifier)="cancelChatSelector()"
    ></app-chats-selector>
  </div>
</ng-template>
